<script>
import fullDineInMixin from 'src/pages/mixin/fullDineInMixin.js';

export default {
  mixins: [fullDineInMixin],
};
</script>
<script setup>
// eslint-disable-next-line import/order
import { ref, provide, computed, onMounted } from 'vue';
import HeadRefresh from 'src/components/HeadRefresh.vue';
import MButton from 'src/components/MButton/index.vue';
import { onBeforeRouteLeave, useRoute } from 'src/utils/v2_helper/router';
import { use18n, useIns } from 'src/utils/v2_helper/common';
import { getOrderInfo } from 'src/api/order';
import { useLoading } from 'src/utils/hooks/loading';
import { setTable } from 'src/utils/common';
import { codeToRoute, isVirtual, PAY_PATH_MAP } from '../util';
import HeadTitle from '../../result/components/HeadTitle.vue';
import Receipt from '../components/Receipt.vue';

const STATE_BG_MAP = {
  FullPaySuccess: '#10b981',
  FullCashWaiting: '#ffffff',
  FullCanceled: '#ffffff',
};
const app = useIns();
const route = useRoute();
const { loading, hide } = useLoading();
const { $t } = use18n();

// 评论地址
const horegoReviewUrl = ref('');
const reviewUrl = computed(() => {
  if (horegoReviewUrl.value) {
    if (/^https?:\/\//.test(horegoReviewUrl.value)) {
      return horegoReviewUrl.value;
    }
    return 'https://dashboard.bakmigm.co.id/';
  }
  return false;
});

const TITLE_MAP = {
  FullPaySuccess: $t('fullDinein.paySucc'),
  FullCashWaiting: $t('fullDinein.waitPay'),
  FullCanceled: $t('fullDinein.orderCanceledTitle'),
};

const orderData = ref({});
const titleOpacity = ref(0);
const detail = computed(() => orderData.value?.orderDetail || {});
const style = computed(() => ({ '--bgColor': STATE_BG_MAP[route.name] }));
const orderId = computed(() => route.query.orderId || app.fullDineInOrderId);
const payment = computed(() => detail.value?.payments?.[0] || {});
const headTitle = computed(() => TITLE_MAP[route.name]);
const showRefresh = computed(() => route.name === 'FullCashWaiting');

async function checkStatus({ order }) {
  try {
    orderData.value = order;
    const oId = orderId.value || app.fullDineInOrderId;
    // app.timer = setTimeout(checkStatus, 3000);
    const { trackingStatusCode } = detail.value?.shipment || {};
    const { paymentStatus, reviewUrl: resReviewUrl } = orderData.value;
    horegoReviewUrl.value = resReviewUrl;
    // route jump
    const routeName = codeToRoute(trackingStatusCode, paymentStatus);
    if (!routeName) return Error('result page RouteName is empty');
    if (routeName !== route.name) {
      const { paymentType, paymentMethodName } = payment.value;
      // 支付等待跳转
      if (routeName === 'FullPayWaiting') {
        if (isVirtual(paymentType)) {
          app._rpush({
            name: 'virtual-account',
            query: { orderId: oId },
          });
        } else {
          const payWaitingRouteName = PAY_PATH_MAP[paymentMethodName];
          app._rpush({
            name: payWaitingRouteName,
            query: { orderId: oId },
          });
        }
      } else {
        // 订单状态跳转
        app._rpush({ name: routeName, query: { orderId: oId } });
      }
    }
  } catch (error) {
    // ERROR_CODE
    console.log('[RESULT_STATUS_ERR]: ', error);
  }
}

const refreshing = ref(false);
function refresh() {
  refreshing.value = true;
  loading();
  getOrderInfo({ orderId: orderId.value })
    .then((res) => {
      orderData.value = res.data;
      hide();
    })
    .catch((e) => console.log(e))
    .finally(() => {
      refreshing.value = false;
    });
}
function onBack() {
  app.$router.replace({ name: 'order-history' });
}

function onScroll(e) {
  titleOpacity.value = e.target.scrollTop / 200;
}

// TODO: depreacated pooling status
onBeforeRouteLeave((from, to, next) => {
  clearTimeout(app.timer);
  next();
});

onMounted(() => {
  refresh();
  if (orderId.value) {
    app.onFullDineInChange('order', checkStatus, { orderId: orderId.value });
  }
});

provide('orderData', orderData);
provide('show_product_status', false);
</script>

<template>
  <q-no-ssr>
    <div class="rs" :style="style" @scroll="onScroll">
      <HeadTitle
        :title="headTitle"
        :is-gradient="route.name === 'FullPaySuccess'"
        :gradient="titleOpacity"
        @back="onBack"
      />
      <HeadRefresh
        v-if="showRefresh"
        :refreshing="refreshing"
        @click="refresh"
      />
      <router-view />
      <Receipt />
      <!-- <div class="rs-back">
        <MButton @click="app._rpush({ name: 'products-list' })">{{
          $t('result.goHome')
        }}</MButton>
      </div> -->
      <div class="rs-back row q-gutter-x-md q-mt-md">
        <div class="col">
          <q-btn
            no-caps
            class="full-width bg-white border-radius-8"
            outline
            color="grey-4"
            unelevated
            @click="app._rpush({ name: 'products-list' })"
          >
            <span class="text-black">{{ $t('result.goHome') }}</span>
          </q-btn>
        </div>
        <div v-if="route.name === 'FullPaySuccess' && reviewUrl" class="col">
          <q-btn
            no-caps
            unelevated
            :href="reviewUrl"
            target="_blank"
            color="primary"
            class="full-width border-radius-8"
          >
            <span class="flex">
              <i class="iconfont dm-a-Pencilalt" />
              <span class="q-ml-sm">Add Review</span>
            </span>
          </q-btn>
        </div>
      </div>
    </div>
  </q-no-ssr>
</template>

<style scoped lang="scss">
.rs {
  position: relative;
  background-color: var(--bgColor);
  padding-bottom: 40px;
  height: 100%;
  overflow: auto;
  .refresh {
    color: #000;
  }
  &-back {
    display: flex;
    padding: 0 24px;
    button {
      flex: 1;
    }
  }
}
</style>
